import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

export const BASE_DEPARTMENT_URL = `${SERVER_API}/catalogs/departments`;

export const ADMINISTRATION_DEPARTMENTS = {
  ...generateCrudEndpoints(`${BASE_DEPARTMENT_URL}`),
  CREATE: {
    method: 'POST',
    url: `${BASE_DEPARTMENT_URL}`,
  } as IEndpointData,
  LIST_BRIEF_TREE: {
    method: 'GET',
    url: `${BASE_DEPARTMENT_URL}/brief-tree`,
  } as IEndpointData,
  INFO(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_DEPARTMENT_URL}/${id}/info`,
    };
  },
};
